import { Stack, Typography } from "@mui/material"
import { makeStyles } from "tss-react/mui"

import { LocalizedStrict } from "../../../modules/localization/components/AppLocalized"
import { TranslationKey } from "../../../modules/localization/translations"
import { StandardButton } from "../buttons/StandardButton"

const useStyles = makeStyles()((theme) => ({
    section: {
        paddingLeft: ".75rem",
        paddingRight: ".75rem",
        gridColumn: "1 / -1",
        paddingTop: ".5rem",
    },
    button: {
        padding: 0,
        color: theme.palette.text.secondary,
        fontWeight: "normal",
        "&:hover": {
            textDecoration: "underline",
            background: "transparent",
        },
    },
}))

export type TopBarNewMenuShortcutConfig = Readonly<{
    id: string
    labelId: TranslationKey
    onClick: () => void
}>

type TopBarNewButtonShortcutsProps = Readonly<{
    shortcuts: ReadonlyArray<TopBarNewMenuShortcutConfig>
    onShortcutClick: (shortcut: TopBarNewMenuShortcutConfig) => void
}>

export function TopBarNewButtonShortcuts({ shortcuts, onShortcutClick }: TopBarNewButtonShortcutsProps) {
    const { classes } = useStyles()

    if (!shortcuts.length) return null

    return (
        <Stack gap=".625rem" className={classes.section}>
            <LocalizedStrict id="top-bar-new-menu-shortcuts-title">
                <Typography variant="subtitle1" color="text.primary">
                    Shortcuts:
                </Typography>
            </LocalizedStrict>
            <Stack alignItems="flex-start" gap=".25rem">
                {shortcuts.map((shortcut) => (
                    <LocalizedStrict key={shortcut.id} id={shortcut.labelId}>
                        <StandardButton
                            variant="text"
                            fullWidth={false}
                            onClick={() => onShortcutClick(shortcut)}
                            size="medium"
                            updateDefaultClasses={classes.button}
                        >
                            Shortcut
                        </StandardButton>
                    </LocalizedStrict>
                ))}
            </Stack>
        </Stack>
    )
}
